import { render, staticRenderFns } from "./PresetIcon.vue?vue&type=template&id=adb8625c&scoped=true"
import script from "./PresetIcon.vue?vue&type=script&lang=js"
export * from "./PresetIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adb8625c",
  null
  
)

export default component.exports